export default "__VITE_ASSET__DNhjRqLm__"